<template>
  <div class="steps__container">
    <div class="col-12 mt-3"></div>

    <div v-if="!mantenimiento">
      <Informacion
        @onMounted="fillData"
        @onApiReady="setApiState"
        @onChangeStep="navigate"
        ref="datos"
        :payload="payload.datos"
        :apistate="dataComponent.datos"
        :modalkm="modalkm"
        :modalEmailTel="modalEmailTel"
        :tel_email="tel_email"
        @update:modalkm="updateModalkm"
        @update:modalEmailTel="EmailTelM"
        @update:tel_email="updatetel_email"
        data-name="datos"
        v-if="current == 1"
        class="animate__animated animate__fadeIn"
      />

      <Coberturas
        @onChangeStep="navigate"
        @onApiReady="setApiState"
        @onCostoCobCalculado="handleCostoCoberturas"
        data-name="basicas"
        :payload="payload.datos"
        :payloadCobs="payload.basicas"
        :apistate="dataComponent"
        :allCobs.sync="allCobs"
        :total.sync="totalCostoCobs"
        v-if="current == 2"
        class="animate__animated animate__fadeIn"
        :selectedPlan.sync="selectedPlan"
      />

      <Cotizacion
        ref="miCotizacion"
        @onSendCotizacion="handleModalSendCot"
        @onChangeStep="navigate"
        data-name="cotizacion"
        :payload="payload.datos"
        :basicas="allCobs[selectedPlan].COBERTURAS"
        :total="allCobs[selectedPlan].TOTALPAQUETE"
        :totalextra="allCobs[selectedPlan].TOTALCOBEXTRA"
        v-if="current == 3"
        class="animate__animated animate__fadeIn"
        :idCotizacion.sync="idCotizacion"
        :primas.sync="primas"
        :planSelectedPrimas.sync="planSelectedPrimas"
        :paquete.sync="allCobs[selectedPlan].PAQUETE"
        :tipoPaquete.sync="allCobs[selectedPlan].TIPOPAQUETE"
        :showCotizacionExitosa.sync="showCotizacionExitosaSinCorreo"
        :verCotizacionModal.sync="verCotizacionModal"
        :pdfBase.sync="pdfBase"
        :phoneCondiciones.sync="phoneCondiciones"
        :modelo.sync="modelo"
        :marca.sync="marca"
      />

      <Poliza
        @onMounted="fillData"
        @onApiReady="setApiState"
        @onChangeStep="navigate"
        ref="datos"
        :poliza.sync="payload.poliza"
        :total="totalCostoCobs"
        data-name="datos"
        v-if="current == 4"
        class="animate__animated animate__fadeIn"
        :primas.sync="primas"
        :planSelectedPrimas.sync="planSelectedPrimas"
        :idCotizacion.sync="idCotizacion"
        :idPoliza.sync="idPoliza"
        :urlPayment.sync="urlPayment"
        :enviarPDF="descargarPDF"
        :referencia.sync="referenciaPayment"
        :datosCotizacion="cotizacionGuardada"
        :email.sync="emailpoliza"
        :showPolizaExitosa.sync="abrirModalPolizaExitosa"
        :showPolizaExitosaSinDocs.sync="abrirModalPolizaExitosaSinDocs"
      />
    </div>
    <div class="text-center" v-if="mantenimiento">
      <h2>Pagina en mantenimiento</h2>
    </div>

    <!-- Modal Enviar Cotización -->
    <CModal title="Enviar cotización" :show.sync="modalSendCot">
      <template #footer-wrapper><span></span></template>
      <template #header>
        <CButtonClose @click="modalSendCot = false" />
      </template>
      <CRow>
        <CCol col="12">
          <CCardBody>
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div
              class="form-group mt-3 text-center pl-4 pr-4"
              v-if="sendTo == 'email'"
            >
              <h4>
                ¡Tu Cotización {{ idCotizacion }}
                <span style="font-weight: bold">será enviada</span>!
              </h4>
              <p class="mt-3">Ingrese el correo:</p>
              <input
                type="email"
                class="form-control"
                v-model="emailSendCotizacion"
                 @change="changeEmail($event)"
              />
              <p style="font-size: 13px; color: gray;" class="mt-2">
                Valida que la dirección de correo sea correcta, ya que no se podrá modificar más adelante.
              </p>
            </div>

            <div class="form-group" v-if="sendTo == 'wh'">
              <label for=""
                >Ingrese el número donde enviaremos la cotización</label
              >
              <input type="email" class="form-control" />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 d-flex justify-content-center">
                <button
                  class="btn btn-primary btn-rounded"
                  @click="enviarCotizacion(sendTo)"
                >
                  Enviar
                </button>
              </div>
            </div>
          </CCardBody>
        </CCol>
      </CRow>

      <template><span></span></template>
    </CModal>

    <!-- Modal Cotización Exitosa -->
    <CModal
      title="Cotización exitosa"
      :show.sync="showCotizacionExitosaSinCorreo"
      :no-close-on-backdrop="true"
    >
      <template #footer-wrapper><span></span></template>
      <template #header>
        <CButtonClose @click="redirectCotizacionSinCorreo()" />
      </template>
      <CRow>
        <CCol col="12">
          <CCardBody>
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 text-center">
                <h2 class="fw-bold">
                  ¡El número de tu poliza es {{ idPoliza }} !
                </h2>
                <p>
                  <span class="fw-bold"
                    >Para elegir tu forma de pago cierra esta ventana</span
                  >
                  o bien si deseas consultarla puedes hacerlo en la sección de
                  Cotizaciones y Pólizas.
                </p>
              </div>
            </div>
          </CCardBody>
        </CCol>
      </CRow>

      <template><span></span></template>
    </CModal>

    <!-- Modal kilometraje -->
    <CModal title="Enviar cotización" :show.sync="modalkm">
      <template #footer-wrapper><span></span></template>
      <template #header>
        <CButtonClose @click="modalkm = false" />
      </template>
      <CRow>
        <CCol col="12">
          <CCardBody>
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>
            <div class="row">
              <div class="col">
                <h5 class="text-center"><b>¿El km ingresado es correcto?,</b> recuerda que si es mayor puede tener cargos adicionales.</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center mt-3">
                <button class="btn btn-primary btn-rounded" @click="callInfo"> Confirmar </button>
              </div>
            </div>
          </CCardBody>
        </CCol>
      </CRow>

      <template><span></span></template>
    </CModal>

    <!-- Modal telefono y correo -->
    <CModal title="Enviar cotización" :show.sync="modalEmailTel">
      <template #footer-wrapper><span></span></template>
      <template #header>
        <CButtonClose @click="modalEmailTel = false" />
      </template>
      <CRow>
        <CCol col="12">
          <CCardBody>
            <div class="text-center">
              <img
              class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>
            <div class="row mt-2">
              <div class="col">
                <h5 class="text-center">Recuerda que el <b>{{ tel_email }}</b> debe ser del contratante.</h5>
              </div>
            </div>
            
          </CCardBody>
        </CCol>
      </CRow>

      <template><span></span></template>
    </CModal>

    <!-- Modal Cotización Exitosa -->
    <CModal
      title="Cotización exitosa"
      :show.sync="showCotizacionExitosa"
      :no-close-on-backdrop="true"
    >
      <template #footer-wrapper><span></span></template>
      <template #header>
        <CButtonClose @click="showCotizacionExitosa = false" />
      </template>
      <CRow>
        <CCol col="12">
          <CCardBody>
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 text-center">
                <h4>
                  ¡Tu {{ typeEmailSuccess || "Cotización" }}
                  <span class="fw-bold">fue enviada correctamente</span>!
                </h4>
                <p v-if="typeEmailSuccess">
                  Hemos enviado toda la información a tu correo:
                </p>
                <p>{{ emailSuccess }}</p>
              </div>
            </div>
          </CCardBody>
        </CCol>
      </CRow>

      <template><span></span></template>
    </CModal>

    <!-- Modal Ver Cotización -->
    <CModal title="Ver cotización" :show.sync="verCotizacionModal">
      <template #footer-wrapper><span></span></template>
      <template #header>
        <CButtonClose @click="verCotizacionModal = false" />
      </template>
      <CRow>
        <CCol col="12">
          <CCardBody>
            <div class="row">
              <div class="col-md-12">
                <iframe
                  :src="'data:application/pdf;base64,' + pdfBase"
                  height="100%"
                  width="100%"
                ></iframe>
              </div>
            </div>
          </CCardBody>
        </CCol>
      </CRow>

      <template><span></span></template>
    </CModal>

    <!-- Modal Pago -->
    <div
      class="modal fade"
      id="staticPayment"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticPaymentLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="border-radius: 30px; border: 0 solid">
          <div
            class="modal-header"
            style="border-bottom: 0 solid !important; padding: 25px"
          >
            <button
              type="button"
              class="btn-close"
              @click="verifyBillingNetpay"
            ></button>

            <button
              id="closeModalPago"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="display: none"
            ></button>
          </div>
          <div class="modal-body text-center">
            <div class="text-center">
              <img
                class="img-fluid w-75 mb-3"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div v-if="paymentAlert" class="alert alert-danger" role="alert">
              El pago no se ha realizado o aun no se ha reflejado, intentalo
              nuevamente
            </div>

            <iframe :src="urlPayment" width="425" height="600"></iframe>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Condiciones -->
    <div
      class="modal fade"
      id="sendCondiciones"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="border-radius: 30px; border: 0 solid">
          <div
            class="modal-header"
            style="border-bottom: 0 solid !important; padding: 25px"
          >
            <button
              id="closeSendCondiciones"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 pl-5 pr-5 text-center">
                <p>
                  <span style="font-weight: bold"
                    >Válida que la información sea correcta</span
                  >, enviaremos las Condiciones Generales de nuestro Seguro al
                  siguiente número del cliente:
                </p>
                <input
                  type="number"
                  class="form-control"
                  v-model="phoneCondiciones"
                  @change="changeTelefono($event)"
                />
                <p class="mt-3">
                  <span style="font-weight: bold">Importante:</span> Una vez
                  enviadas las Condiciones Generales ya no se podrá modificar 
                  el número telefónico ni la cotización.
                </p>
                <button
                  class="btn btn-primary btn-rounded mt-3"
                  @click="enviarCondiciones()"
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Poliza -->
    <div
      class="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="border-radius: 30px; border: 0 solid">
          <div
            class="modal-header"
            style="border-bottom: 0 solid !important; padding: 25px"
          >
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="reloadPage()"
            ></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 text-center">
                <h2>
                  ¡El automóvil ya se encuentra
                  <span class="fw-bold">protegido con Valor Latino!</span>
                </h2>
                <p>
                  Toda la información correspondiente a la Póliza se envío al
                  siguiente correo del cliente:
                </p>
                <p>{{ this.emailpoliza }}</p>
                <p>
                  Recuerda que en unos minutos recibirá la liga para realizar la
                  inspección.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Poliza Exitosa -->
    <div
      class="modal fade"
      id="showModalPolizaExitosa"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="showModalPolizaExitosaLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="border-radius: 30px; border: 0 solid">
          <div
            class="modal-header"
            style="border-bottom: 0 solid !important; padding: 25px"
          >
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="redirectPoliza()"
            ></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 text-center">
                <h4 class="fw-bold">
                  ¡El número de tu poliza es {{ idPoliza }}!
                </h4>
                <p>
                  <span class="fw-bold"
                    >Para elegir tu forma de pago cierra esta ventana</span
                  >
                  o bien si deseas consultarla puedes hacerlo en la sección de
                  Cotizaciones y Pólizas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Poliza Exitosa sin Envio de Docs -->
    <div
      class="modal fade"
      id="showModalPolizaExitosaSinDocs"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="showModalPolizaExitosaSinDocsLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="border-radius: 30px; border: 0 solid">
          <div
            class="modal-header"
            style="border-bottom: 0 solid !important; padding: 25px"
          >
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="redirectPoliza()"
            ></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <img
                class="img-fluid w-75"
                :src="require('@/assets/icons/ValorLatino.png')"
                alt="ValorLatino"
              />
            </div>

            <div class="row">
              <div class="col-md-12 mt-4 text-center">
                <p class="fw-bold">
                  Estimado Agente o Promotor, te recordamos que para poder
                  emitir tu póliza, es necesario realizar primero la inspección
                  del vehículo.
                </p>
                <p class="fw-bold">
                  Este proceso debe de realizarlo tu Asegurado para obtener su
                  seguro.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      id="messagePolizaModal"
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#staticBackdrop"
      style="display: none"
    >
      MessagePoliza
    </button>

    <button
      id="polizaModal"
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#staticPayment"
      style="display: none"
    >
      Poliza
    </button>

    <button
      id="sendCondicionesModal"
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#sendCondiciones"
      style="display: none"
    >
      Condiciones
    </button>

    <button
      id="modalPolizaExitosa"
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#showModalPolizaExitosa"
      style="display: none"
    >
      Poliza exitosa
    </button>

    <button
      id="modalPolizaExitosaSinDocs"
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#showModalPolizaExitosaSinDocs"
      style="display: none"
    >
      Poliza exitosa sin Docs
    </button>
  </div>
</template>

<script>
import ProgressBar from "../tools/ProgressBar.vue";

import Informacion from "./steps/Datos.vue";
import Coberturas from "./steps/CobsInc.vue";
import Cotizacion from "./steps/Cotizacion.vue";
import Poliza from "./steps/Poliza.vue";

import ResumeBar from "../tools/ResumeBar.vue";

import { format } from "../../../assets/helpers";

export default {
  components: {
    Informacion,
    Coberturas,
    Cotizacion,
    Poliza,
    ProgressBar,
    ResumeBar,
  },
  methods: {},
  data() {
    return {
      //modals nuevos
      modalEmailTel: false,
      modalkm: false,
      tel_email: "",

      mantenimiento: false,
      modalSendCot: false,
      sendTo: null,
      emailSendCotizacion: "",
      current: 1,
      modelo: null,
      version: null,
      agentName: null,
      totalCostoCobs: 0,
      dataComponent: {
        datos: {
          marcas: [],
          modelos: [],
          submarcas: [],
          agentes: [],
          selected: {},
        },
        cobs: [],
      },
      payload: {
        datos: null,
        cobs: null,
        poliza: null,
        payment: null,
      },
      steps: ["Datos personales", "Coberturas", "Cotización", "Poliza"],
      selectedPlan: 0,
      allCobs: [],
      idCotizacion: "",
      idPoliza: "",
      primas: [],
      planSelectedPrimas: 0,
      urlPayment: "",
      showCotizacionExitosa: false,
      showCotizacionExitosaSinCorreo: false,
      verCotizacionModal: false,
      pdfBase: "",
      emailSuccess: "",
      typeEmailSuccess: "",
      referenciaPayment: "",
      paymentAlert: false,
      phoneCondiciones: "",
      cotizacionGuardada: {},
      emailpoliza: "",
      marca: "",
    };
  },
  methods: {
    changeEmail(event){
      console.log(event.target.value);
      this.payload.datos.email = event.target.value
    },
    changeTelefono(event){
      console.log(event.target.value);
      console.log( this.payload);
      this.payload.datos.telefono = event.target.value
    },
    callInfo() {
      this.$refs.datos.handleNavigation(); // Llamar al método del componente hijo
      this.modalkm = false
    },
    updateModalkm(newValue) {
      this.modalkm = newValue;
    },
    EmailTelM(newValue) {
      this.modalEmailTel = newValue;
    },
    updatetel_email(newValue) {
      console.log(newValue);
      this.tel_email = newValue;
    },

    navigate(step, from = null, payload = null) {
      if (from) {
        this.payload[from] = payload;
      }

      if (step == 1) {
        this.totalCostoCobs = 0;
      }

      this.current = step;
    },
    handleCostoCoberturas(monto) {
      this.totalCostoCobs = monto.toFixed(2);
    },
    handleModalSendCot(destin) {
      this.emailSendCotizacion = this.payload.datos.email;
      this.modalSendCot = true;
      this.sendTo = destin;
    },
    fillData(component) {
      if (this.payload.length == 0) {
        return;
      }

      if (this.payload[component]) {
        Object.entries(this.payload[component]).forEach((item) => {
          const elementHTML = document.querySelector(`[name='${item[0]}']`);
          if (elementHTML) {
            elementHTML.value = item[1];
          }
        });
      }
    },
    setApiState({ section, api, data }) {
      this.dataComponent[section][api] = data;
    },
    async getAgente() {
      const payload = {
        metodo: "GET_AGENTE",
        data: {
          ClaveAgente: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        this.agentName = this.$store.getters.getRespuestaREST.psNombre_Agente;
      } else {
        this.agentName = "Agente no encontrado";
      }
    },
    async enviarCotizacion(via) {
      if (via === "email") {
        this.descargarPDF(12);
        this.modalSendCot = false;
      }
    },
    async sendCotizacionEmail(pdf, type) {
      console.log(
        this.emailSendCotizacion !== ""
          ? this.emailSendCotizacion
          : this.emailpoliza
      );

      const payload = {
        metodo: "SENDEMAILCOTIZACION",
        data: {
          idTemplate: "17",
          sender: "infolatino@latinoseguros.com.mx",
          subject: `Latino Seguros ${
            type === 12
              ? "Cotización " + this.idCotizacion.toString()
              : "Póliza " + this.idPoliza.toString()
          }`,
          targets:
            this.emailSendCotizacion !== ""
              ? this.emailSendCotizacion
              : this.emailpoliza,
          dinamicContent: `${
            type === 12 ? "Cotización" : "Póliza"
          } de tu seguro de auto.`,
          idMessage: "",
          attachments: [
            {
              file: pdf,
              name: `${type === 12 ? "cotizacion" : "poliza"}.pdf`,
            },
          ],
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const _ = this.$store.getters.getRespuestaREST;
        this.showCotizacionExitosa = type === 12;
        this.typeEmailSuccess = type === 12 ? "Cotización" : "Póliza";
        this.emailSuccess =
          this.emailSendCotizacion !== ""
            ? this.emailSendCotizacion
            : this.emailpoliza;
        this.emailSendCotizacion = "";
      }
    },
    async descargarPDF(type) {
      this.$store.dispatch("enableLoading").then((_) => {});
      const payload = {
        metodo: "OBTIENEPDFDOCS",
        data: {
          POLIZA: type === 11 || type === 13 ? this.idPoliza : "",
          ENDOSO: "",
          COTIZACION: this.idCotizacion,
          RECIBO: "",
          TIPOCOTIZADOR: 2,
          TIPODOCUMENTO: type,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        if(type == 12) {
          await this.$refs.miCotizacion.guardarCotizacionEmail();
        }
        await this.sendCotizacionEmail(response.data, type);
      }
      this.$store.dispatch("disabledLoading").then((_) => {});
    },
    async inspeccion() {
      const payload = {
        metodo: "INSPECCIONV3",
        data: {
          ApellidoMaterno: "",
          ApellidoPaterno: "",
          Email: localStorage.getItem("userIdLog"),
          Geolocalizacion:"",
          Kilometraje: this.informacion.km.model,
          Marca: this.informacion.marca.model,
          Modelo: this.informacion.modelo.model,
          Nombre: this.informacion.nombre.model,
          NumeroInciso: "001",
          NumeroPoliza: this.idCotizacion,
          idRenovacion: 0,
          idOpcional: 0,
          Placa: "",
          Submarca: this.informacion.submarca.model,
          Telefono: this.informacion.telefono.model,
          VIN: "LSGKB54H2JV155125",
          Agente: "15664",
          Promotor: "5444",
          idClienteUnico: "2747707",
          idCatProducto: 3,
          idRamo: "34",
          movimiento: "Inspeccion",
          NumeroRenovacion: "",
          tipoUnidad: "AU",
          tramite: "Anexo",
          vehiculo: this.informacion.version.model,

          /*NumeroPoliza: this.idCotizacion,
          Inciso: "1",
          VIN: "LSGKB54H2JV155125",
          IdClienteUnico: "2747707",
          NombreAs: this.informacion.nombre.model,
          ApePat: "",
          ApeMat: "",
          Placa: "",
          NumCelularAs: this.informacion.telefono.model,
          NumAlternoAs: "",
          EmailAs: localStorage.getItem("userIdLog"),
          tipoUnidad: "AU",
          Marca: this.informacion.marca.model,
          Submarca: this.informacion.version.model,
          Modelo: this.informacion.modelo.model,
          Anio: this.informacion.anio.model,
          Agente: "15664",
          Promotor: "5444",
          MovimientoVil: "Inspeccion",
          TipoTramiteVil: "Anexo",
          IdOperacion: 2,*/
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        console.log(response);
      }
    },
    async verifyBillingNetpay() {
      this.paymentAlert = false;

      const payload = {
        metodo: "CONSULTARRESPUESTAPAGOBANREGIO",
        data: {
          Referencia: this.referenciaPayment,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        if (response !== null) {
          const close = document.getElementById("closeModalPago");
          const polizaModal = document.getElementById("messagePolizaModal");

          close.click();
          polizaModal.click();
        }
      } else {
        this.paymentAlert = true;
      }
    },
    reloadPage() {
      window.location.href = `#/cotizador/auto`;
      location.reload();
    },
    async enviarCondiciones() {
      const payload = {
        metodo: "ENVIOCONDICIONESGENERALES",
        data: {
          renovacion: "0",
          cotizacion: this.idCotizacion,
          cotizador: "2",
          telefono: this.phoneCondiciones,
          vehiculo: `${this.marca}-${this.modelo}`,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const _ = this.$store.getters.getRespuestaREST;
        document.getElementById("closeSendCondiciones").click();
        this.$refs.miCotizacion.guardarCondiciones(this.phoneCondiciones);
        window.location.href = `#/cotizador/auto/cotizaciones-poliza`;
        location.reload();
      }
    },
    async obtieneCotizacionGuardada() {
      const payload = {
        metodo: "OBTIENEGUARDADOCOTIZACION",
        data: {
          CLIENTE: {},
          INCISOS: [
            {
              COBERTURAS: [{}],
            },
          ],
          COTIZACION: this.idCotizacion,
          POLIZA: "",
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.cotizacionGuardada = response[0];
        this.current = 4;
        this.navigate(4);
      }
    },
    redirectPoliza() {
      window.location.href = `#/cotizador/auto/cotizaciones-poliza`;
      location.reload();
    },
    redirectCotizacionSinCorreo() {
      this.showCotizacionExitosaSinCorreo = false;
      window.location.href = `#/cotizador/auto/cotizaciones-poliza`;
      location.reload();
    },
    abrirModalPolizaExitosa() {
      document.getElementById("modalPolizaExitosa").click();
    },
    abrirModalPolizaExitosaSinDocs() {
      document.getElementById("modalPolizaExitosaSinDocs").click();
    },
  },
  computed: {
    totalNumber() {
      return format.money(this.totalCostoCobs);
    },
  },
  mounted() {
    this.idCotizacion = this.$route.query.idCotizacion;

    if (this.idCotizacion === undefined) {
      this.getAgente();
      this.idCotizacion = "";
    } else {
      this.obtieneCotizacionGuardada();
    }
  },
};
</script>

<style lang="scss">
.navbar--menu-open {
  width: calc(100% - 256px);
}
.floating-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(51, 153, 255, 0.7);

  button {
    color: white;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    &:nth-child(1) {
      z-index: 2;
      transition: all 0.3s ease;
    }

    &:nth-child(2) {
      opacity: 0;
    }
    &:nth-child(3) {
      opacity: 0;
    }
  }
}
.floating-button--active {
  button {
    &:nth-child(1) {
      opacity: 50%;
      transform: rotate(45deg);
    }

    &:nth-child(2) {
      top: 0;
      transition: all 0.3s ease;
      left: -50px;
      opacity: 100% !important;
    }
    &:nth-child(3) {
      top: 0;
      transition: all 0.3s ease;
      left: -100px;
      opacity: 100% !important;
    }
    &:nth-child(4) {
      top: 0;
      transition: all 0.3s ease;
      left: -150px;
      opacity: 100% !important;
    }
    &:nth-child(5) {
      top: 0;
      transition: all 0.3s ease;
      left: -200px;
      opacity: 100% !important;
    }
  }
}
@media only screen and (max-width: 600px) {
  .more__buttons button {
    display: none;
  }
}
@media only screen and (min-width: 600px) {
  .floating-button {
    display: none;
  }
}

.steps__container {
  position: relative;
  min-height: calc(100vh - 154px);
}

.modal-header {
  border-bottom: 0px solid !important;
}
</style>
